import { useQuery } from "react-query";
import { IPayDebt } from "../../../../../types/common.interface";
import api from "../../../../../api";

const GetUserInfo = (selectedDebt: any) => {
  // !! ===========================================================================================================
  // !!                                            Company
  // !! ----------------------------------------------------------------------------------------------------------

  const companyResult = useQuery(
    ["company_info", selectedDebt?._id],
    () =>
      api.post.administrator.getAllCompany({
        search: { base: "phoneNumber", value: selectedDebt.phoneNumber },
      }),
    { enabled: selectedDebt?.type === "COMPANY" }
  )?.data?.result[0];
  const companyInfo = [
    {
      name: "نام شرکت",
      value: companyResult?.companyInformation?.companyName,
      id: "name",
    },
    // {
    //   name: "شهر",
    //   value: companyResult?.companyInformation?.city,
    // },
    // {
    //   name: "استان",
    //   value: companyResult?.companyInformation?.province,
    // },
    {
      name: "شناسه ملی",
      value: companyResult?.companyInformation?.nationalId,
    },
    {
      name: "شماره ثبت",
      value: companyResult?.companyInformation?.registrationNumber,
    },
    {
      name: "نام مدیر شرکت",
      value: companyResult?.firstName + " " + companyResult?.lastName,
      id: "lastName",
    },
    {
      name: "شماره مدیر شرکت",
      value: companyResult?.phoneNumber,
    },
    {
      name: "کدملی مدیر شرکت",
      value: companyResult?.companyInformation?.nationalCode,
    },
    {
      name: "شماره کارت",
      value: companyResult?.financial?.kartNumber,
    },
    {
      name: "شماره شبا",
      value: companyResult?.financial?.shabaNumber,
    },
  ];

  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             driver
  // !! ===========================================================================================================

  const driverResult = useQuery(
    ["driver_info", selectedDebt?._id],
    () =>
      api.post.common.findDriver({
        search: { base: "phoneNumber", value: selectedDebt.phoneNumber },
      }),
    { enabled: selectedDebt?.type === "DRIVER" }
  )?.data?.result[0];
  const driverInfo = [
    {
      name: "نام راننده",
      value: driverResult?.firstName + " " + driverResult?.lastName,
      id: "name",
    },
    {
      name: "موبایل راننده",
      value: driverResult?.phoneNumber,
      id: "lastName",
    },
    // {
    //   name: "کدملی",
    //   value: driverResult?.companyInformation?.nationalCode,
    // },
    {
      name: "شماره کارت",
      value: driverResult?.financial?.kartNumber,
    },
    {
      name: "شماره شبا",
      value: driverResult?.financial?.shabaNumber,
    },
  ];
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             municipality
  // !! ===========================================================================================================

  const municipalityResult = useQuery(
    ["municipality_info", selectedDebt?._id],
    () =>
      api.post.administrator.getAllMuniciPality({
        search: { base: "phoneNumber", value: selectedDebt.phoneNumber },
      }),
    { enabled: selectedDebt?.type === "MUNICIPALITY" }
  )?.data?.result[0];
  const municipalityInfo = [
    {
      name: "نام شهرداری",
      value: municipalityResult?.firstName + " " + municipalityResult?.lastName,
      id: "name",
    },
    {
      name: "موبایل شهرداری",
      value: municipalityResult?.phoneNumber,
      id: "lastName",
    },
    {
      name: "کدملی",
      value: municipalityResult?.companyInformation?.nationalCode,
    },
    {
      name: "شماره کارت",
      value: municipalityResult?.financial?.kartNumber,
    },
    {
      name: "شماره شبا",
      value: municipalityResult?.financial?.shabaNumber,
    },
  ];
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             superAgent
  // !! ===========================================================================================================

  const superAgentResult = useQuery(
    ["superAgent_info", selectedDebt?._id],
    () =>
      api.post.administrator.getAllSuperAgent({
        search: { base: "phoneNumber", value: selectedDebt.phoneNumber },
      }),
    { enabled: selectedDebt?.type === "SUPERAGENT_SCHOOL" }
  )?.data?.result[0];
  const superAgentInfo = [
    {
      name: "نام آموزش و پرورش",
      value: superAgentResult?.firstName + " " + superAgentResult?.lastName,
      id: "name",
    },
    {
      name: "شماره موبایل",
      value: superAgentResult?.phoneNumber,
      id: "lastName",
    },

    {
      name: "شماره کارت",
      value: superAgentResult?.financial?.kartNumber,
    },
    {
      name: "شماره شبا",
      value: superAgentResult?.financial?.shabaNumber,
    },
  ];

  let info: { name: string; value: string }[] = [];

  switch (selectedDebt?.type) {
    case "COMPANY":
      info = companyInfo;
      break;
    case "DRIVER":
      info = driverInfo;
      break;
    case "MUNICIPALITY":
      info = municipalityInfo;
      break;
    case "SUPERAGENT_SCHOOL":
      info = superAgentInfo;
      break;
  }
  return info;
};

export default GetUserInfo;
